module.exports = __webpack_public_path__ + "img/empreendimento-logo-8.e680bc93.png";